import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';

import appStore from '../../assets/img/app-store.png';
import googlePlay from '../../assets/img/google-play.png';

const APP_STORE_URL = 'https://apps.apple.com/br/app/obmep-mirim-professores/id6812005617';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.impa.obmepmirimprofessoresapp&hl=pt_BR';

const MENSAGEM_PADRAO = 'A digitalização das provas é feita exclusivamente pelo aplicativo OBMEP Mirim Professores.';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
    },
    mensagem: {
        color: theme.palette.text.secondary,
        maxWidth: 360,
        textAlign: 'right',
    },
    badges: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    badge: {
        display: 'inline-flex',
        lineHeight: 0,
        borderRadius: 8,
        transition: theme.transitions.create('opacity'),
        '&:hover': {
            opacity: 0.85,
        },
    },
    imagem: {
        display: 'block',
        height: 36,
        width: 'auto',
    },
}));

export const DownloadApps = ({ mensagem, compacto }) => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            { !compacto &&
                <Typography variant="caption" className={classes.mensagem}>
                    {mensagem ?? MENSAGEM_PADRAO}
                </Typography>
            }

            <div className={classes.badges}>
                <a
                    href={APP_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.badge}
                    aria-label="Baixar o aplicativo OBMEP Mirim Professores na App Store"
                >
                    <img src={appStore} alt="Baixar na App Store" className={classes.imagem} />
                </a>

                <a
                    href={PLAY_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.badge}
                    aria-label="Baixar o aplicativo OBMEP Mirim Professores no Google Play"
                >
                    <img src={googlePlay} alt="Disponível no Google Play" className={classes.imagem} />
                </a>
            </div>
        </Box>
    );
}

export default DownloadApps;
